module.exports = __webpack_public_path__ + "img/rob-min.224e6926.png";